import { TwilioError } from './types';

const twilioErrors = new Map<number, string>([
  [21610, 'Attempt to send to unsubscribed recipient.'],
]);

const defaultErrorText = 'An unknown error has occurred.';

export const twilioErrorMapper = (error?: TwilioError): string => {
  if (!error || (!error.code && !error.errorMessage)) {
    return defaultErrorText;
  }

  if (!error.code && error.errorMessage) {
    return error.errorMessage;
  }

  return (
    (twilioErrors.has(error.code)
      ? twilioErrors.get(error.code)
      : error.errorMessage) || defaultErrorText
  );
};
